module.exports = __webpack_public_path__ + "static/media/departments.88d2aa47.png";